import moment from 'moment';

class DashboardController {
    constructor($rootScope, $scope, $state, access, authService, dataApiService, $modal, storeService, propertiesService, propertyGroupService, loadingService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.access = access;
        this.userData = authService.getProfile();
        this.dataApiService = dataApiService;
        this.$modal = $modal;
        this.storeService = storeService;
        this.propertiesService = propertiesService;
        this.propertyGroupService = propertyGroupService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.relativeTimes = this.relativeTimeScale();

        if (this.access.check('only_investor') && this.$state.current.name === 'app.dashboard') {
            this.$state.go('app.admin.revenueDashboard');
        }

        if (this.access.check('only_premier') && this.$state.current.name === 'app.dashboard') {
            this.$state.go('app.admin.premierDashboard');
        }

        if (this.access.check('reporting') || this.access.check('investor')) {
            this.timeFrame = this.isGlobal ? 'This month' : 'This week';

            this.showGroupData = this.storeService.get('group_dashboard') || false;

            this.getReportData(true);

            if (this.isGlobal) {
                this.getProperties();
            }
            if (this.isRevenue) {
                this.getAccountSummaryData();
            }
        }
    }

    getReportData (setTimeFrame) {
        if (this.isDataLoading()) {
            return;
        }

        if (setTimeFrame && !this.setTimeFrame()) {
            return false;
        };

        if (this.isGlobal) {
            return this.getGlobalData();
        }

        if (this.isBestSellers) {
            return this.getBestSellersDetails();
        }

        this.getClientData();
    }

    getGlobalData () {
        this.setProperty();

        this.getRevenueByTypeData();

        if (this.isRevenue) {
            this.getOrdersData();
            this.getAccountStatsData();
            this.getCommissionData();
            this.getOrdersRCData();
            this.getUpgradesData();
            this.getAverageSpendData();
            this.getPaidExtrasData();

            return;
        }

        this.getSalesByTypeData();
        this.getMetricsData();
        this.getPopularOfferData();
        this.getPopularOptionsData();
        this.getPopularDurationData();
        this.getBestSellersData();
        this.getLeaderboardData();
        this.getTreatmentsData();
        this.getOrderInsightsData();
    }

    getClientData () {
        this.getRevenueByTypeData();
        this.getSalesByTypeData();
        this.getAverageSpendData();
        this.getUpgradesData();
        this.getOrdersData();
        this.getBestSellersData();
        this.getPaidExtrasData();
        this.getTreatmentsData();
    }

    getSalesByTypeData () {
        this.loadingService.startLoading('salesByType');
        return this.dataApiService.getData('salesByType', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('salesByType');
            this.salesByType = response;
            this.salesByType.total = (this.salesByType.Treatment || 0) +
                (this.salesByType.SpaDay || 0) +
                (this.salesByType.EventExtra || 0);
        });
    }

    getRevenueByTypeData () {
        this.loadingService.startLoading('revenueByType');
        return this.dataApiService.getData('revenueByType', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('revenueByType');
            this.revenueByType = response;

            this.transformRevenueByType();
        });
    }

    getAverageSpendData () {
        this.loadingService.startLoading('averageSpend');
        return this.dataApiService.getData('averageSpend', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('averageSpend');
            this.averageSpend = response;
        });
    }

    getBestSellersData () {
        this.loadingService.startLoading('bestSellers');
        return this.dataApiService.getData('bestSellers', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties, 5).then(response => {
            this.loadingService.stopLoading('bestSellers');
            this.bestSellers = response;
        });
    }

    getUpgradesData () {
        this.loadingService.startLoading('upgrades');
        return this.dataApiService.getData('upgrades', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('upgrades');
            this.upgrades = null;
            if (Object.keys(response).length > 0) {
                this.upgrades = response;
            }
        });
    }

    getOrdersData () {
        this.loadingService.startLoading('orders');
        return this.dataApiService.getData('orders', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('orders');
            this.orders = response;
        });
    }

    getOrdersRCData () {
        this.loadingService.startLoading('ordersRC');
        return this.dataApiService.getData('ordersRC', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('ordersRC');
            this.ordersRC = response;
        });
    }

    getPaidExtrasData () {
        this.loadingService.startLoading('paidExtras');
        return this.dataApiService.getData('paidExtras', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('paidExtras');
            this.paidExtras = response;
        });
    }

    getTreatmentsData () {
        this.loadingService.startLoading('treatments');
        return this.dataApiService.getData('treatments', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('treatments');
            this.treatments = response;
        });
    }

    getMetricsData () {
        this.loadingService.startLoading('metrics');
        return this.dataApiService.getData('metrics', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('metrics');
            this.metrics = response;
        });
    }

    getPopularOptionsData () {
        this.loadingService.startLoading('popularOptions');
        return this.dataApiService.getData('popularOptions', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties, 5).then(response => {
            this.loadingService.stopLoading('popularOptions');
            this.popularOptions = response;
        });
    }

    getPopularDurationData () {
        this.loadingService.startLoading('popularDuration');
        return this.dataApiService.getData('popularDuration', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties, 5).then(response => {
            this.loadingService.stopLoading('popularDuration');
            this.popularDuration = response;
        });
    }

    getPopularOfferData () {
        this.loadingService.startLoading('popularOffer');
        return this.dataApiService.getData('popularOffer', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('popularOffer');
            this.popularOffer = response;
        });
    }

    getCommissionData () {
        this.loadingService.startLoading('commission');
        return this.dataApiService.getData('commission', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('commission');
            this.commission = this.orderByCurrency(response);
        });
    }

    getAccountStatsData () {
        this.loadingService.startLoading('accountStats');
        return this.dataApiService.getData('accountStats', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('accountStats');
            this.accountStats = response;

            for (const status in this.accountStats) {
                this.orderByCurrency(this.accountStats[status]);
            }
        });
    }

    getAccountSummaryData () {
        this.loadingService.startLoading('accountSummary');
        return this.dataApiService.getData('accountSummary', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('accountSummary');
            this.accountSummary = response;

            this.transformAccountSummary();
        });
    }

    getLeaderboardData () {
        this.loadingService.startLoading('leaderboard');
        return Promise.all([
            this.dataApiService.getData('revenueLeaderboard', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
                this.revenueLeaderboard = response;
            }),
            this.dataApiService.getData('orderLeaderboard', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
                this.orderLeaderboard = response;
            })
        ]).then(() => {
            this.loadingService.stopLoading('leaderboard');
            this.$scope.$digest();
        });
    }

    getOrderInsightsData () {
        this.loadingService.startLoading('orderInsights');
        return this.dataApiService.getData('orderInsights', this.dateFrom, this.dateTo, this.showGroupData, this.showGlobalData, this.scopeProperties).then(response => {
            this.loadingService.stopLoading('orderInsights');
            this.orderInsights = response;
        });
    }

    setTimeFrame () {
        this.dateFrom = moment();
        this.dateTo = moment();

        switch (this.timeFrame) {
            case 'This week':
                this.dateFrom.startOf('week').add(1, 'day');
                this.dateTo.endOf('week').add(1, 'day');
                break;
            case 'Last week':
                this.dateFrom = this.dateFrom.subtract(1, 'week').startOf('week').add(1, 'day');
                this.dateTo = this.dateTo.subtract(1, 'week').endOf('week').add(1, 'day');
                break;
            case 'This month':
                this.dateFrom.startOf('month');
                this.dateTo.endOf('month');
                break;
            case 'Last month':
                this.dateFrom.subtract(1, 'month').startOf('month');
                this.dateTo.subtract(1, 'month').endOf('month');
                break;
            case 'This year':
                this.dateFrom.startOf('year');
                this.dateTo.endOf('year');
                break;
            case 'Last year':
                this.dateFrom.subtract(1, 'year').startOf('year');
                this.dateTo.subtract(1, 'year').endOf('year');
                break;
            case 'Custom':
                if (!this.customDateFrom && !this.customDateTo) {
                    return false;
                }
                this.dateFrom = this.customDateFrom;
                this.dateTo = this.customDateTo;
                break;
        }

        this.setDateFromTo(this.dateFrom, this.dateTo);
        return true;
    }

    setDateFromTo (dateFrom, dateTo) {
        this.timeFrameString = `${dateFrom.format('Do MMMM, YYYY')}&ndash;${dateTo.format('Do MMMM, YYYY')}`;
        this.dateFrom = dateFrom.format('YYYY-MM-DD');
        this.dateTo = dateTo.format('YYYY-MM-DD');
    }

    welcome () {
        let string = 'Good morning';
        let hour = moment().hour();
        if (hour >= 12) {
            string = 'Good afternoon';
        }
        if (hour >= 18) {
            string = 'Good evening';
        }
        string += `, ${this.userData.nickname[0].toUpperCase()}${this.userData.nickname.substring(1)}`;

        return string;
    }

    thisMonth () {
        return moment().format('MMMM YYYY');
    }

    lastMonth () {
        return moment().subtract(1, 'month').format('MMMM YYYY');
    }

    thisYear () {
        return moment().format('YYYY');
    }

    lastYear () {
        return moment().subtract(1, 'year').format('YYYY');
    }

    findOrder () {
        let modalInstance = this.$modal.open({
            template: `
<form class="row c-list__search c-list__search--user">
    <div class="columns medium-5">
        <select ng-model="$ctrl.filtertype" ng-init="$ctrl.filtertype = $ctrl.filtertype || 'id'">
            <option value="id">Order ID</option>
            <option value="customer.name">Customer Name</option>
            <option value="customer.email">Customer Email</option>
            <option value="order_status_id">Order Status</option>
            <option value="payment_status_id">Payment Status</option>
            <option value="created_at">Date created</option>
            <option value="reference">External Reference</option>
        </select>
    </div>
    <div class="columns medium-7">
        <div class="c-list__search__fields">
            <input class="c-list__search__input" type="text" ng-model="$ctrl.filtertext" ng-show="$ctrl.canFilterText()" placeholder="Filter by {{ $ctrl.displayFiltertype() }}..." autofocus />

            <order-statuses link="$ctrl.filtertext" ng-show="$ctrl.filtertype === 'order_status_id'"></order-statuses>

            <payment-statuses link="$ctrl.filtertext" ng-show="$ctrl.filtertype === 'payment_status_id'"></payment-statuses>

            <div class="c-form__field" ng-show="$ctrl.filtertype === 'created_at'">
                <input name="start_time" type="text" class="c-form__input c-form__input--date" readonly form-field-errors ng-model="$ctrl.filtertext" moment-picker="$ctrl.filtertext" keyboard="true" format="YYYY-MM-DD" min-view="month" max-view="minute" set-on-select="true" autocomplete="off" validate="true">
                <label class="c-form__label" for="start_time">Date</label>
            </div>
            <spinner ng-if="$ctrl.loading" />
        </div>
    </div>
    <div class="columns medium-12">
        <button class="c-list__search__button button round" ng-click="$ctrl.filterOrder()">Search</button>
    </div>
</form>
`,
            windowClass: 'c-modal__reveal',
            controller: 'modalController as $ctrl'
        });

        modalInstance.result.catch(() => { });
    }

    findEvent () {
        let modalInstance = this.$modal.open({
            template: `
<form class="row c-list__search c-list__search--user">
    <div class="columns medium-5">
        <select ng-model="$ctrl.filtertype" ng-init="$ctrl.filtertype = $ctrl.filtertype || 'treatment'">
            <option value="treatment">Treatment</option>
            <option value="spaday">Spa Day</option>
            <option value="option">Mandatory Option</option>
            <option value="extra">Extra / Add on</option>
        </select>
    </div>
    <div class="columns medium-7">
        <div class="c-list__search__fields">
            <input class="c-list__search__input" type="text" ng-model="$ctrl.filtertext" placeholder="Filter by {{ $ctrl.displayFiltertype() }}..." autofocus />
            <spinner ng-if="$ctrl.loading" />
        </div>
    </div>
    <div class="columns medium-12">
        <button class="c-list__search__button button round" ng-click="$ctrl.filterEvent()">Search</button>
    </div>
</form>
`,
            windowClass: 'c-modal__reveal',
            controller: 'modalController as $ctrl'
        });

        modalInstance.result.catch(() => { });
    }

    hasPropertyGroup () {
        return !!this.$rootScope.currentProperty.group_property;
    }

    isDataLoading () {
        return this.loadingService.isLoading();
    }

    groupReportData () {
        this.storeService.set('group_dashboard', this.showGroupData);
        this.getReportData(true);
    }

    getProperties () {
        this.showGlobalData = true;
        this.propertyId = '*';
        this.properties = [];
        this.propertyGroups = [];
        return Promise.all([
            this.propertiesService.findAll(-1).then((response) => {
                this.properties = response;
            }),
            this.propertyGroupService.findAll(-1).then((response) => {
                this.propertyGroups = response;
            })
        ]);
    }

    setProperty () {
        this.scopeProperties = false;

        if (!this.propertyId || this.propertyId === '*' || this.propertyId === 'integrated' || this.propertyId === 'commission') {
            this.showGroupData = false;
            this.showGlobalData = true;

            if (this.propertyId === 'integrated') {
                this.scopeProperties = 'partnerOnly';
                this.transformAccountSummary();
                return;
            }

            if (this.propertyId === 'commission') {
                this.scopeProperties = 'commissionOnly';
            }
            this.transformAccountSummary();
            return;
        }

        if (this.propertyId[0] === 'p') {
            this.showGroupData = false;
            this.showGlobalData = false;
        }

        if (this.propertyId[0] === 'g') {
            this.showGroupData = true;
            this.showGlobalData = false;
        }

        this.dataApiService.setPropertyId(this.propertyId.substring(1));
        this.transformAccountSummary();
    }

    metricsPercent (param) {
        if (!this.loadingService.isLoading('metrics') && this.metrics && Object.values(this.metrics).length > 0) {
            let percent = 0;
            if (this.metrics[param] > 0) {
                percent = ((this.metrics[param] / this.metrics.interactedBaskets) * 100).toFixed(1);
            }

            return `${percent}%`;
        }
    }

    orderInsightPercent (param) {
        if (!this.loadingService.isLoading('orderInsights') && this.orderInsights && this.orderInsights.time && Object.values(this.orderInsights.time).length > 0) {
            let percent = 0;
            if (this.orderInsights.time[param] > 0) {
                percent = ((this.orderInsights.time[param] / this.orderInsights.totalOrders) * 100).toFixed(1);
            }
            if (this.orderInsights[param] > 0) {
                percent = ((this.orderInsights[param] / this.orderInsights.totalOrders) * 100).toFixed(1);
            }

            return `${percent}%`;
        }
    }

    percentageOfTotalOrders (numberOfOrders, currency) {
        if (!this.loadingService.isLoading('orders') && this.orders.length && numberOfOrders > 0) {
            let orderSummary = this.orders.find(orderSummary => {
                return orderSummary.currency === currency;
            });
            return (numberOfOrders / orderSummary.count) * 100;
        }
        return 0;
    }

    sendCommissionReport (type) {
        this.dataApiService.sendCommissionReport(type);
    }

    setCustomDateRange () {
        if (this.customDateFrom && this.customDateTo) {
            this.setDateFromTo(this.customDateFrom, this.customDateTo);
            this.getReportData(false);
        }
    }

    transformAccountSummary () {
        if (this.accountSummary) {
            this.filteredAccounts = [];

            if (!this.propertyId || this.propertyId === '*') {
                this.filteredAccounts = this.accountSummary.map(account => {
                    account.filtered = false;
                    return account;
                });

                return;
            }

            if (this.propertyId === 'integrated') {
                this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(account => {
                    account.filtered = !account.integrated;
                    return account;
                }));

                return;
            }

            if (this.propertyId === 'commission') {
                this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(account => {
                    account.filtered = (account.gateway === 'stripe') ? false : true;
                    return account;
                }));

                return;
            }

            if (this.propertyId[0] === 'p') {
                let property = this.properties.find(property => {
                    return property.id === parseInt(this.propertyId.slice(1));
                });
                this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(account => {
                    account.filtered = (account.name === property.name) ? false : true;
                    return account;
                }));

                return;
            }

            if (this.propertyId[0] === 'g') {
                let group = this.propertyGroups.find(group => {
                    return group.properties.indexOf(parseInt(this.propertyId.slice(1))) > -1;
                });
                this.filteredAccounts = this.orderByFiltered(this.accountSummary.map(account => {
                    account.filtered = (account.propertyGroup === group.name) ? false : true;
                    return account;
                }));

                return;
            }
        }
    }

    transformRevenueByType () {
        Object.values(this.revenueByType).forEach((type) => {
            this.revenueByType.total = this.revenueByType.total || [];

            for (const currency in type) {
                let totalCurrency = this.revenueByType.total.find(existing => {
                    return existing.currency === currency;
                });
                if (totalCurrency) {
                    totalCurrency.value += type[currency];
                    continue;
                }
                this.revenueByType.total.push({
                    currency: currency,
                    value: type[currency]
                });
            }
        });
        if (this.revenueByType.total) {
            this.revenueByType.total = this.orderByCurrency(this.revenueByType.total);
        }
    }

    orderByCurrency (array) {
        return array.sort((a, b) => {
            if (a.currency < b.currency) {
                return -1;
            }
            if (a.currency > b.currency) {
                return 1;
            }
            return 0;
        });
    }

    orderByFiltered (array) {
        return array.sort((a, b) => a.filtered - b.filtered);
    }

    hasData (type) {
        if (typeof this[type] === 'object') {
            return Object.keys(this[type]).length > 0;
        }
        return !!this[type];
    }

    relativeTimeScale () {
        return [
            'Midnight—1 AM',
            '1 AM—2 AM',
            '2 AM—3 AM',
            '3 AM—4 AM',
            '4 AM—5 AM',
            '5 AM—6 AM',
            '6 AM—7 AM',
            '7 AM—8 AM',
            '8 AM—9 AM',
            '9 AM—10 AM',
            '10 AM—11 AM',
            '11 AM—Midday',
            'Midday—1 PM',
            '1 PM—2 PM',
            '2 PM—3 PM',
            '3 PM—4 PM',
            '4 PM—5 PM',
            '5 PM—6 PM',
            '6 PM—7 PM',
            '7 PM—8 PM',
            '8 PM—9 PM',
            '9 PM—10 PM',
            '10 PM—11 PM',
            '11 PM—Midnight',
        ];
    }

    getBestSellersDetails () {
        this.loadingService.startLoading('bestSellers');
        return this.dataApiService.getData('bestSellersDetails', this.dateFrom, this.dateTo)
            .then(response => {
                this.categories = response.categories;
                this.bestSellers = response.items;
                this.filterBestSellers();
            })
            .catch(() => { })
            .then(() => {
                this.loadingService.stopLoading('bestSellers');
            });
    }

    displayType (type) {
        switch (type) {
            case 'Activity':
                return 'Class';
            case 'EventExtra':
                return 'Extra';
            case 'SpaDay':
                return 'Spa Day';
            default:
                return type;
        }
    }

    filterBestSellers () {
        this.hiddenCount = 0;
        this.isFiltered = false;

        this.bestSellers.forEach(items => {
            items.hidden = false;
            items.hiddenCount = 0;
            items.forEach(item => {
                item.hidden = false;
            });

            if (this.categoryFilter === '*' && this.typeFilter === '*') {
                return;
            }

            this.isFiltered = true;

            if (this.categoryFilter !== '*'
                && this.categoryFilter !== items[0].category) {
                ++this.hiddenCount;
                items.hidden = true;
                return;
            }

            if (this.typeFilter !== '*') {
                items.forEach(item => {
                    if (this.typeFilter !== item.type) {
                        ++items.hiddenCount;
                        item.hidden = true;
                    }
                });

                if (items.hiddenCount === items.length) {
                    ++this.hiddenCount;
                    items.hidden = true;
                }
            }
        });
    }

    clearFilter () {
        this.categoryFilter = '*';
        this.typeFilter = '*';
        this.filterBestSellers();
    }

    sumParameter (items, parameter) {
        let total = 0;
        if (items && items.length) {
            items.forEach(item => {
                if (!item.hidden) {
                    total += parseFloat(item[parameter] || 0);
                }
            });
        }
        return total;
    }

    sumLeadTime (items) {
        if (items && items.length) {
            return (this.sumParameter(items, 'lead_days') / items.length).toFixed(1);
        }
        return 0;
    }

    sumSoldItems(items) {
        let total = 0;
        if(items && items.length) {
            items.forEach(item => {
                if (!item.hidden) {
                    total += parseFloat(item.count / (item.minimum_guests || 1));
                }
            });
        }
        return total;
    }
}
DashboardController.$inject = ['$rootScope', '$scope', '$state', 'access', 'authService', 'dataApiService', '$modal', 'storeService', 'propertiesService', 'propertyGroupService', 'loadingService'];

export default DashboardController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/dashboard/controllers/dashboard.controller.js